// extracted by mini-css-extract-plugin
export default {"pageContainer":"pageContainer__zpLSIFg6","titleContainer":"titleContainer__bHQyERg9"};